<section>
  <main [style.fontSize]="fontSize|async">
    <article #quote [ngClass]="{active:isActive(0)|async,previous:isPrevious(0)|async}">
      <p>
        “ Was impressed with how fast the transaction is.
        Very accommodating staff. Highly recommended to all
        ofw who are in need of fast loaning service. Two thumbs
        up!!,and thank you Mr Ivan”
      </p>
      <cite>Jonathan C, Stateroom Steward</cite>
    </article>
    <article #quote [ngClass]="{active:isActive(1)|async,previous:isPrevious(1)|async}">
      <p>
        “ Employees are very hospitable and approachable.
        They entertain the applicants well.”
      </p>
      <cite>Roel B, Quarter Master</cite>
    </article>
    <article #quote [ngClass]="{active:isActive(2)|async,previous:isPrevious(2)|async}">
      <p>
        “ Fast approval! Approachable staff!
        Great customer service”
      </p>
      <cite>Rosalene P, Skin Care Specialist in UAE</cite>
    </article>
  </main>
  <footer fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="16px">
    <button [ngClass]="{active:isActive(0)|async}" (click)="explicitIndex.next(0)"></button>
    <button [ngClass]="{active:isActive(1)|async}" (click)="explicitIndex.next(1)"></button>
    <button [ngClass]="{active:isActive(2)|async}" (click)="explicitIndex.next(2)"></button>
  </footer>
</section>
